import { BaseTLTableComponent, AxiosResponse, tlISODateToLocalString, tlISODateTimeToLocalNoSecondsString, GeneralTermService, GeneralTermFilter, BaseTLTableBase } from "../../../Infrastructure/CorBase/CoreBase";

export default abstract class GeneralTermListBase extends BaseTLTableComponent {

	protected selectedGeneralTermId: number = 0;

	protected generalTermService: GeneralTermService = new GeneralTermService();

	callActionClick() {
		this.deleteItemsList = this.getSelectedList();
		super.deleteList();		
	
	}

	protected deleteListServer(): Promise<AxiosResponse<any>> {
		return this.generalTermService.deleteList(this.deleteItemsList);
	}

	protected contentModal = this.$t('generalTerm.messageQuestionMain').toString();


	agreeClickBase(item:any) {
		this.isBusy = true;
		item.idUser = this.$store.state.idUser;

		if (item.validTo.trim() == '') {
			//@ts-ignore
			delete this.formData.validTo;
		}
		this.generalTermService.consentGeneralTerm(item.id, item).then(res => {
			this.fetchData();
			this.isBusy = false;
		}).catch(error => {
			this.showAlertModalWithErrorMessage(this.$t('errorsall.errorMessageConsentGeneralTerm').toString());
			this.isBusy = false;
		});
	}


	downloadClickBase(item:any) {
		
			this.generalTermService.getOriginalFileById(item.id).then(res => {
				const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
				const link = document.createElement('a');
				link.href = url;
				var nameDocument =item.name + '.pdf';
				link.setAttribute('download', nameDocument); // N�zev souboru pro sta�en�
				document.body.appendChild(link);
				link.click();
				link.remove();
			});
		
	}

	showAgreeButtonBase() {
		return true;
	}



	deleteItem = 0;
	protected showAlertBeforeDeleteBase(itemsSelected: any) {
		this.deleteItem = Number(itemsSelected);
	//	this.contentModal = this.$t('generalTerm.messageQuestionMain').toString();
		this.showAlertBeforeActionClickBase(itemsSelected, this.$t('generalTerm.messageQuestionMain').toString());
		//this.generalTermService.getById(idGeneralTerm).then(res => {
		//	var content = this.$t('generalTerm.messageQuestionMain').toString();
		//	if (res.data.existSchoolYear > 0) {
		//		content = this.$t('generalTerm.messageQuestionDelete1').toString();
		//	}
		//	this.contentModal = content;
		//	this.showAlertBeforeActionClickBase(itemsSelected, content);
		//});
	}

	

	//protected showAllertToDeleteClickListBase(itemsSelected: any) {
	//	this.contentModal = this.$t('generalTerm.messageQuestionMain').toString();
	//	var existWithYear = this.tableData.filter((c: any) => c.existSchoolYear == true && (itemsSelected as Array<any>).indexOf(c.id) != -1).length > 0;

	//	if (existWithYear == true) {
	//		this.contentModal = this.$t('generalTerm.messageQuestionDelete2').toString();
	//	}
	//	this.showAlertBeforeActionClickBase(itemsSelected, this.contentModal,true);
	//}

	itemsFilter = [
		{ value: this.$t('global.answerYes').toString(), text: this.$t('global.answerYes').toString() },
		{ value: this.$t('global.answerNo').toString(), text: this.$t('global.answerNo').toString() }];

	protected setFields() {
		this.fields = [
			//{ key: 'id', label: this.$t('generalTerm.fieldIdentif'), trans: 'generalTerm.fieldIdentif', sortable: true, class: 'text-center' },
			{ key: 'name', label: this.$t('generalTerm.fieldName'), trans: 'generalTerm.fieldName', sortable: true, class: 'text-center' },
			{ key: 'description', label: this.$t('generalTerm.fieldDescription'), trans: 'generalTerm.fieldDescription', sortable: true, class: 'text-center' },
			{ key: 'validFrom', label: this.$t('generalTerm.fieldDateFrom'), trans: 'generalTerm.fieldDateFrom', sortDirection: 'asc', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateToLocalString(x) },
			{ key: 'validTo', label: this.$t('generalTerm.fieldDateTo'), trans: 'generalTerm.fieldDateTo', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateToLocalString(x) },
			{ key: 'sendNotification', label: this.$t('generalTerm.fieldDateNotification'), trans: 'generalTerm.fieldDateNotification', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateToLocalString(x) },


			
			{ key: 'publicationDate', label: this.$t('generalTerm.fieldPublish'), trans: 'generalTerm.fieldPublish', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateToLocalString(x) },
			{ key: 'consentDate', label: this.$t('generalTerm.fieldConsentDate'), trans: 'generalTerm.fieldConsentDate', sortable: true, class: 'text-left', formatter: (x: Date) => tlISODateTimeToLocalNoSecondsString(x) },
			{ key: 'consentUser', label: this.$t('generalTerm.fieldConsentUser'), trans: 'generalTerm.fieldConsentUser', sortable: true, class: 'text-center' },

			{ key: 'actions', label: this.$t('generalTerm.fieldAction'), trans: 'generalTerm.fieldAction', class: 'text-right', thClass: 'lastColumnMichael' }
		]
	};

	protected setfilters(value: any) {
		if (value != null) {
			this.filters = value;
		}
		else {
			this.filters = [
				{ key: 'name', label: this.$t('generalTerm.fieldName'), trans: 'generalTerm.fieldName', selected: false, value: null, type: 'text' },
				{ key: 'description', label: this.$t('generalTerm.fieldDescription'), trans: 'generalTerm.fieldDescription', selected: false, value: null, type: 'text' }
			];
		}
	}


	protected fetchData() {
		super.fetchData();
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		let generalTermFilter: GeneralTermFilter = new GeneralTermFilter(null);
		return this.generalTermService.getAllByFilter(generalTermFilter);
	}

	//zat�m nepotrebujeme
	fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return this.fetchDataFromServer();
	}

	refreshItems(items: any[], refreshData: any[]) {
		return items;
	}

	


	protected prepareItems(items: any[]) {
		//for (var i = 0; i < items.length; i++) {
		//	var prepare = this.prepareAfterLoad(items[i].subjectDtb);
		//	items[i].subjectTooltip = prepare.length> 17 ?this.prepareHtml(prepare): '';
		//	items[i].subjectText = prepare.substr(0, 20);
		//	items[i].studentIsInDebtText = this.$t(checkBoxToString(items[i].studentIsInDebt)).toString();
		//	items[i].inPriceListText = this.$t(checkBoxToString(items[i].inPriceList)).toString();
		//}
	};
}